import { observer } from 'mobx-react-lite';
import PreviewElementRenderer from './PreviewElementRenderer';
import type { PreviewElementRendererProps } from './types';

export type { PreviewElementRendererProps };
export default observer(PreviewElementRenderer);
